import React, { useState } from 'react';
import { Layout, Alert, Button, Drawer, Grid } from 'antd';
import { LayoutProps } from '../../types';
import { TenantSider } from './TenantSider';
import { TenantHeader } from './TenantHeader';
import { TenantBreadcrumb } from './TenantBreadcrumb';
import { TenantFooter } from './TenantFooter';
import { EventProvider } from '../../contexts/EventContext';
import { useAuth } from '../../contexts/AuthContext';

const { Content } = Layout;
const { useBreakpoint } = Grid;

export const AppLayout: React.FC<LayoutProps> = ({ children, tenant, user }) => {
  const { user: authUser, isImpersonating, stopImpersonation } = useAuth();
  const screens = useBreakpoint();
  const isMobile = !screens.lg;
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleStopImpersonation = async () => {
    await stopImpersonation();
    // Full reload so the restored admin session gets a clean tenant/permission
    // context instead of the impersonated one.
    window.location.assign('/admin/users');
  };

  return (
    <EventProvider>
      <Layout className="app-layout" style={{ minHeight: '100vh' }}>
        {!isMobile && <TenantSider tenant={tenant} user={user} />}
        {isMobile && (
          <Drawer
            placement="left"
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
            closable={false}
            width={256}
            styles={{ body: { padding: 0, background: '#0B2523' } }}
          >
            <TenantSider tenant={tenant} user={user} mode="drawer" onNavigate={() => setDrawerOpen(false)} />
          </Drawer>
        )}
        <Layout>
          <TenantHeader tenant={tenant} user={user} isMobile={isMobile} onMenuClick={() => setDrawerOpen(true)} />
          {isImpersonating && (
            <Alert
              type="warning"
              banner
              showIcon
              message={
                <span>
                  You are impersonating <strong>{authUser?.email}</strong>.
                </span>
              }
              action={
                <Button size="small" type="primary" danger onClick={handleStopImpersonation}>
                  Exit impersonation
                </Button>
              }
            />
          )}
          <Content>
            <TenantBreadcrumb />
            <div className="content-wrapper" style={{ padding: isMobile ? 12 : 24, background: '#fff', borderRadius: 6 }}>
              {children}
            </div>
          </Content>
          <TenantFooter tenant={tenant} />
        </Layout>
      </Layout>
    </EventProvider>
  );
};